/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DermOnCall Patient API
 * OpenAPI spec version: 1.0
 */
import { useMutation } from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';

import type {
  UpdateImageErrorResponse,
  UpdateImageRequest,
  UpdateImageResponse,
} from './api.schemas';

import { api } from '../util/http';

export const updateEncountersImages = (
  encounterId: number,
  imageId: number,
  updateImageRequest: UpdateImageRequest,
) => {
  return api<UpdateImageResponse>({
    url: `/api/encounters/${encounterId}/images/${imageId}`,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    data: updateImageRequest,
  });
};

export const getUpdateEncountersImagesMutationOptions = <
  TError = UpdateImageErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateEncountersImages>>,
    TError,
    { encounterId: number; imageId: number; data: UpdateImageRequest },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateEncountersImages>>,
  TError,
  { encounterId: number; imageId: number; data: UpdateImageRequest },
  TContext
> => {
  const mutationKey = ['updateEncountersImages'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateEncountersImages>>,
    { encounterId: number; imageId: number; data: UpdateImageRequest }
  > = (props) => {
    const { encounterId, imageId, data } = props ?? {};

    return updateEncountersImages(encounterId, imageId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateEncountersImagesMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateEncountersImages>>
>;
export type UpdateEncountersImagesMutationBody = UpdateImageRequest;
export type UpdateEncountersImagesMutationError = UpdateImageErrorResponse;

export const useUpdateEncountersImages = <TError = UpdateImageErrorResponse, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateEncountersImages>>,
      TError,
      { encounterId: number; imageId: number; data: UpdateImageRequest },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateEncountersImages>>,
  TError,
  { encounterId: number; imageId: number; data: UpdateImageRequest },
  TContext
> => {
  const mutationOptions = getUpdateEncountersImagesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
